<template>
    <div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">옵션상품관리</h2>
          <article>
            <ul class="search_filter">
              <li style="max-width:50%">
                <p>옵션상품명</p>
                <input type="text" placeholder="옵션상품명을 입력하세요" class="form_control" v-model="searchInfo.optionGoodsNm" @keyup.enter="fn_search_first">
              </li>
              <li style="flex:1 1 0; min-width:0">
                <button class="btn btn_md btn_outline" @click="fn_search_first">조회</button>
              </li>
            </ul>
          </article>
        </section>
        <section class="view">
          <div class="table_list">
            <div class="table_option">
              <div class="form_select"></div>
              <button class="btn btn_md btn_darkblue" @click="fn_move_optionReg">신규상품 등록</button>
            </div>
            <table class="list">
              <thead>
                <tr>
                  <th style="width:7.6%; line-height:1.5">옵션상품 이미지</th>
                  <th>옵션상품명</th>
                  <th>상품설명</th>
                  <th>가격</th>
                  <th>사용여부</th>
                  <th>관리</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="optionGoodsList.length == 0">
                    <td colspan="6"><span>데이터가 없습니다.</span></td>
                </tr>
                <tr v-for="(item, index) in optionGoodsList" :key="index">
                  <td>
                    <span class="img_area">
                      <img :src="'/file/getImgFile/' + item.option_goods_file_id" alt="">
                    </span>
                  </td>
                  <td><span>{{ item.option_goods_nm }}</span></td>



                  <td><span>{{ item.option_goods_descript }}</span></td>
                  <td><span>{{ fn_comma_won(item.option_goods_price) }}</span></td>
                  <td><span>{{ item.use_yn }}</span></td>
                  <td>
                    <div class="form_inline">
                      <button class="icon icon_del" @click="fn_delete(item)"></button>
                      <button class="icon icon_edit" @click="fn_move_dtl_page(item.option_goods_seq)"></button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <Pagination :pageInfo="searchInfo.pageInfo" @clickPage="fn_movePage" v-show="pagingShow"/>
          </div>
        </section>
      </div>
    </div>
</template>

<script>
  import axios from 'axios'
  import Pagination from "@/components/AdminPagination.vue"
  import commonUtil from "@/mixin/commonUtil";

  export default {
    name: 'OptionGoodsMngt',
    mixins: [commonUtil],
    components: {
      Pagination,
    },
    data() {
      return {
        searchInfo : {
          optionGoodsNm : '',
          pageInfo : {
            page : 1,
            pageSize : 10,
            totPage : 0
          }
        },
        pagingShow : false,
        optionGoodsList: [],
      }
    },
    created(){
        this.fn_search();
    },
    methods : {
      fn_search(){
        axios
            .post("/api/admin/promise/searchOptionGoods", this.searchInfo)
            .then((res) => {
                this.optionGoodsList = res.data.optionList;
                this.searchInfo.pageInfo.totPage = res.data.totCnt;
                this.pagingShow = this.searchInfo.pageInfo.totPage > 0;
            })
            .catch((err) => console.log(err));
      },
      fn_search_first(){
        this.searchInfo.pageInfo.page = 1;
        this.fn_search();
      },
      fn_movePage(page){
        this.searchInfo.pageInfo.page = page;
        this.fn_search();
      },
      fn_move_optionReg(){
        this.$store.dispatch('promise/setOptionGoodsSeq', '');
        this.$store.dispatch('promise/setStatus', '');
        this.$router.push("/admin/promise/optionGoodsReg");
      },
      fn_move_dtl_page(optionGoodsSeq){
        this.$store.dispatch('promise/setOptionGoodsSeq', optionGoodsSeq);
        this.$store.dispatch('promise/setStatus', 'M');
        this.$router.push("/admin/promise/optionGoodsReg");
      },
      fn_delete(item){
        if(confirm("정말로 삭제하시겠습니까?")){

          axios
              .post("/api/admin/promise/deleteOptionGoods", item)
              .then(() => {
                  this.fn_search();
              })
              .catch((err) => console.log(err));
        }
      },
    }
  }
</script>
